import useTable from '../../../hooks/useTable';
import { Table } from '../../Table';
import { TableComponentProps } from '../types';

const columnLables = {
  exchanged_traded_derivatives_exposure: {
    name: 'Exchange-traded Derivatives: Gross exposure less margin posted',
    order: 229,
    letter: 'A'
  },
  otc_derivatives_amount: {
    name: 'OTC Derivatives: Gross exposure less margin posted',
    order: 230,
    letter: 'A'
  },
  short_position_borrowed_securities: {
    name: 'Value of securities borrowed for short position',
    order: 231,
    letter: 'A'
  }
};

export function DerivativesExposure({
  funds,
  onChangeFund,
  currentDataKey,
  schema,
  isStaticTemplate,
  isMultiFunds
}: TableComponentProps) {
  const {
    rows: rows,
    columns: columns,
    onChange: onChange
  } = useTable({
    data: funds[currentDataKey]?.fund_data?.DERIVATIVE_EXPOSURE,
    onChangeFund,
    schema: schema.DERIVATIVE_EXPOSURE,
    isStaticTemplate,
    requiredFields: funds[currentDataKey]?.required_tables?.DERIVATIVE_EXPOSURE?.field_names || [],
    columnLables,
    tableName: 'DERIVATIVE_EXPOSURE',
    isMultiFunds,
    funds
  });

  return (
    <Table
      id="fca-reporttables-derivatives-exposure-table"
      stickyLeftColumns={isMultiFunds && Object.keys(funds).length > 2 ? 3 : null}
      handleChanges={onChange}
      columns={columns}
      rows={rows}
    />
  );
}
